// THE RIDE — Spor1's tour (Build_Game_Intro §4.2), as data.
//
// The tour IS the map tutorial: driving past each landmark reveals it, in the
// spec's order — Studio, Record Store, Listening Room, Concert Hall, Cinema —
// and the drop-off is the salon kerb, because the salon is what comes next
// (§2's reorder: ride → salon → the walk → studio).
//
// The route is a LOOP on purpose. The conversation decides when the ride ends
// (Spor1 closes the scene; the car "takes the long way around" is literal), so
// the path has no finish line — after the last point it re-enters at `loopTo`
// and keeps circling until the scene closes and the drop-off glide takes over.
//
// Points are world [x, z] at street level, same space as CITY_ROUTES — trace
// tighter onto the real streets with the same ?routes=edit workflow whenever
// the block changes. Reveal positions/names come from TOWN_LOCATIONS at fire
// time, so moving a venue moves its reveal with no edit here.

export const RIDE_SPEEDS = {
  // touring 7 → 5.5 (Khari, 2026-08-03: landmarks and their lines were
  // arriving "far too fast" — the cached clips deliver instantly, so the CAR
  // has to make the space the old model latency used to fake).
  touring: 5.5,
  smooth: 8, stopping: 5.5, fast: 11, slow: 5,
};

// SPOR1'S LOTUS — the game's actual start (Khari's call, 2026-08-02): Lyra
// rings ~30s in and says find him — "main strip, yellow Lotus, you can't miss
// it." The car is a real parked object (elise.glb, tinted); the pickup prompt
// is proximity-gated to it, and the ride route begins exactly where it sits.
// Finding the car is the first errand — movement taught BEFORE the guided
// sequence, agency before the tour.
export const SPOR1_CAR = {
  pos: [6, 14.8],        // main strip kerb, east of the studio block
  rotY: -Math.PI / 2,    // nose west, along the strip — the way the ride goes
  reach: 7,              // how close "found him" is
};

export const INTRO_RIDE = {
  pace: 'touring',
  loopTo: 2,      // laps re-enter here (skip the kerb pickup points)
  route: [
    [6, 14.8],            // Spor1's Lotus — the ride starts where the car sits
    [0, 14.4],
    [-8, 14],
    [-22, 13.5],          // ── STUDIO goes past
    [-32, 12],
    [-34, 0],
    [-30, -8],
    [-16, -10],
    [0, -10.5],
    [14, -10],
    [20, -4],
    [20, 8],              // ── RECORD STORE goes past
    [18, 14],
    [8, 16],
    [-2, 20],
    [-6, 26],             // ── LISTENING ROOM goes past
    [-2, 30],
    [8, 30],
    [16, 30],
    [22, 30],             // ── CONCERT HALL goes past
    [20, 36],
    [12, 39],
    [4, 39],              // ── THE CINEMA goes past
    [-4, 34],
    [-8, 28],
    [-12, 20],
    [-14, 14],
    [-11, 14.1],          // rejoins the main street → loops to index 2
  ],
  // `line` is what the WORLD tells the scene when the landmark goes past — the
  // parenthetical Spor1 answers as the city, not as the player. One line each;
  // he does the actual talking.
  reveals: [
    { atIndex: 3,  key: 'studio',         line: 'lit up on the corner — the rooms where the records get made' },
    { atIndex: 11, key: 'record-store',   line: 'crates in the window going back decades' },
    { atIndex: 15, key: 'listening-room', line: 'small room, serious ears — first plays happen in there' },
    { atIndex: 19, key: 'concert-hall',   line: 'the big stage, marquee dark tonight' },
    { atIndex: 22, key: 'theater',        line: 'the cinema — premiere nights fill the whole block' },
  ],
  // The salon kerb (§4.2 "Ends: he pulls up at the salon"). x/z only — the
  // sequence lands you at street eye height and WalkControls takes it from there.
  dropoff: { pos: [-30, -4], look: [-30, 6] },
};
